module.exports = __webpack_public_path__ + "img/f94dda3.png";